import moment from 'moment';

export const TodayTomorrowYesterday = (date) => {
  const dayInMills = 24 * 60 * 60 * 1000;
  const nowStartOfDay = moment().startOf('day');
  const dateStartOfDay = moment(date).startOf('day');
  const diff = dateStartOfDay.diff(nowStartOfDay);
  switch(diff){
    case -(dayInMills * 6):
    case -(dayInMills * 5):
    case -(dayInMills * 4):
    case -(dayInMills * 3):
    case -(dayInMills * 2):
      return `Last ${dateStartOfDay.format('dddd')}`;
    case -(dayInMills):
      return 'Yesterday';
    case 0:
      return 'Today';
    case dayInMills:
      return 'Tomorrow';
    case dayInMills * 6:
    case dayInMills * 5:
    case dayInMills * 4:
    case dayInMills * 3:
    case dayInMills * 2:
      return `${dateStartOfDay.format('dddd')}`;
    default:
      return dateStartOfDay.format('MM/DD/YY')
  }
}
